<template>
  <div id="app">
    <HelloWorld msg="Welcome to Your Vue.js App"/>
  </div>
</template>

<script>
import HelloWorld from './components/index.vue'

export default {
  name: 'App',
  components: {
    HelloWorld
  },
  mounted() {
    this.disableRightClick()
    this.disableF12()
    this.disableImageDownload()
    this.disableMediaDownload()
  },
  methods: {
    disableRightClick() {
      document.addEventListener('contextmenu', (e) => {
        e.preventDefault()
      })
    },
    disableF12() {
      document.addEventListener('keydown', (e) => {
        if (e.key === 'F12') {
          e.preventDefault()
        }
        if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key === 'I') {
          e.preventDefault()
        }
        if ((e.ctrlKey || e.metaKey) && e.key === 'U') {
          e.preventDefault()
        }
        if ((e.ctrlKey || e.metaKey) && e.key === 'S') {
          e.preventDefault()
        }
      })
    },
    disableImageDownload() {
      const images = document.querySelectorAll('img')
      images.forEach(img => {
        img.setAttribute('draggable', 'false')
        img.oncontextmenu = (e) => {
          e.preventDefault()
        }
      })
    },
    disableMediaDownload() {
      const media = document.querySelectorAll('audio, video')
      media.forEach(el => {
        el.setAttribute('controlslist', 'nodownload')
      })
    }
  }
}
</script>

<style>
*{
  padding: 0;
  margin: 0;
  list-style: none;
  text-decoration: none;
}
</style>
